import { UserService } from '@services/user/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { CameraWasteService } from '@services/cameraWaste/CameraWasteService';
import { ApplicationApi } from '@classes/application/application';
import { Camera } from '@classes/camera/camera';
import { ClientSmartHub } from '@classes/client/client';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from '@services/application/application.service';
import { CamerasService } from '@services/cameras/cameras.service';
import { ClientService } from '@services/client/client.service';
import { AddUsersComponent } from '../add-users/add-users.component';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-admin-list-camera',
  templateUrl: './admin-list-camera.component.html',
  styleUrls: ['./admin-list-camera.component.scss'],
})
export class AdminListCameraComponent implements OnInit {
  faPlus = faPlus;
  faSearch = faSearch;
  cameraWaste: CameraWaste[];
  show = true;
  clients: ClientSmartHub[];
  applications: ApplicationApi[];
  cameras: Camera[];
  displayedColumns: string[] = ['name', 'battery', 'externalId', 'lastLogon'];
  dataSource: MatTableDataSource<Camera>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(
    private clientService: ClientService,
    private dialog: MatDialog,
    private applicationService: ApplicationService,
    private cameraService: CamerasService,
    private CameraWasteService: CameraWasteService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.getAllClient();
    this.getAllApplications();

    this.userService.clientChangedSubject.subscribe(() => {
      // this.isLoading = true;

      this.getCamera();
    });

    this.getCamera();
  }

  applyFilter(event): void {}

  openDialogAddUsers(client: ClientSmartHub): void {
    const dialogRef = this.dialog.open(AddUsersComponent, {
      data: {
        client,
      },
      height: '80vh',
      width: '60%',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllClient();
      this.getAllApplications();
      // this.getCameras();
    });
  }

  getCamerasByClient(client: string): Camera[] {
    return (
      this.cameras?.filter((cameras) => cameras.client.name === client) || []
    );
  }

  private getAllClient(): void {
    this.clientService.getAllClients().subscribe({
      next: (clients) => {
        this.clients = clients;
      },
    });
  }

  private getAllApplications(): void {
    this.applicationService.getAllApplications().subscribe({
      next: (applications) => {
        this.applications = applications;
      },
    });
  }
  private getCamera(): void {
    this.cameraService.getCameras().subscribe((res) => {
      this.cameras = res;

      this.dataSource = new MatTableDataSource<Camera>(this.cameras);

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
